import {
  BasketTitle,
  DeliveriesSkeleton,
  RowSection,
} from '@aboutyou/ui-components';

import React from 'react';
import {BasketFAQSkeleton} from '../BasketFAQ/BasketFAQ.skeleton';
import {BasketInfoSkeleton} from '../BasketInfo/BasketInfo.skeleton';
import {BasketSplitView} from '../BasketSplitView/BasketSplitView';
import {BasketTotalSkeleton} from '../BasketTotal/BasketTotal.skeleton';
import {UnavailableProductsSkeleton} from '../UnavailableProducts/UnavailableProducts.skeleton';

export const BasketPageSkeletonDesktop = () => {
  return (
    <>
      <RowSection>
        <BasketTitle />
      </RowSection>
      <BasketSplitView
        contentStart={
          <>
            <DeliveriesSkeleton />
            <UnavailableProductsSkeleton />
            <BasketFAQSkeleton />
          </>
        }
        contentEnd={
          <>
            <BasketInfoSkeleton />
            <BasketTotalSkeleton />
            <BasketInfoSkeleton />
          </>
        }
      />
    </>
  );
};
